/*global SkrKaffiliate */
import {debounce} from './helpers';

export default function () {
    const searchButton = document.querySelector('.search-toggle');
    if (searchButton === null) {
        return;
    }
    const searchInput = document.querySelector('#navigation-search [name="s"]');
    const navigation = document.querySelector('#navigation');
    const processChange = debounce((e, input) => ajaxSearch(e, input));

    // Handle click on search icon in header and open search form
    searchButton.addEventListener('click', function (e) {
        e.preventDefault();
        navigation.classList.toggle('search-is-active');

        if (navigation.classList.contains('search-is-active')) {
            searchInput.focus();
        }
    });

    // Handle type in search form and submit ajax request
    searchInput.addEventListener('keyup', (e) => processChange(e, searchInput));
}

function ajaxSearch(e, input) {
    if (!input.classList.contains('searching')) {
        let query = input.value;
        let form = input.parentElement;
        if (query.length > 2) {
            input.classList.add('searching');
            form.querySelector('.search_result').innerHTML = '';

            let data = new FormData();
            data.append('action', 'kfr_ajax_search');
            data.append('security', SkrKaffiliate.ajax.nonce);
            data.append('query', query);

            fetch(SkrKaffiliate.ajax.url, {
                body: data,
                method: 'POST',
            })
                .then((data) => {
                    if (data.ok) {
                        return data.json();
                    } else {
                        console.error('Error');
                    }
                })
                .then((response) => {
                    form.querySelector('.search_result').innerHTML += response.data;
                })
                .catch((error) => {
                    console.error('Error', error);
                })
                .finally(()=>{
                    input.classList.remove('searching');
                });
        }
    }
}
